import { createAction, handleActions } from 'redux-actions';

// ACTION CREATORS
export const getPartnersConfig = createAction('GET_PARTNERS_CONFIG');
export const setPartnersConfig = createAction('SET_PARTNERS_CONFIG');
export const savePartnersConfig = createAction('SAVE_PARTNERS_CONFIG');

// REDUCERS
export const reducer = handleActions(
  new Map([
    [
      setPartnersConfig,
      (state, action) => {
        return action.payload
      } 
    ]
  ]),
  [] 
);